/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IInvoiceDetailsViewProps } from './gdn-invoice-details';

export const InvoiceDetailsView: React.FC<IInvoiceDetailsViewProps> = props => {
    const { header, products, paymentDetails, shipmentDetails, /*payInvoiceError,*/ invoiceDetailsError } = props;

    return (
        <Module {...props.moduleProps}>
            <div id='wrapper'>
                {invoiceDetailsError ? (
                    invoiceDetailsError
                ) : (
                    <>
                        {header}
                        {products}
                        {paymentDetails}
                        <div className='pagebreak'> </div>
                        {shipmentDetails}
                        {/* {payInvoiceError} */}
                    </>
                )}
            </div>
        </Module>
    );
};

export default InvoiceDetailsView;
